import { get } from "lodash-es";

export const ordersParser = (response) => {
    try {
        if (response?.result) {
            response = response.result;
        }
        if (!response) {
            return {
                results: [],
                count: 0,
                pageNo: 0,
                limit: 10,
                sortBy: "DESC",
                sortField: "created_at",
            };
        }
        if (response.results)
            response.results = response.results.map((row, key) => {
                return {
                    id: get(row, "id", ""),
                    order_number: get(row, "order_number", ""),
                    customer: {
                        id: get(row, "customer.id", ""),
                        name: get(row, "customer.name", ""),
                        email: get(row, "customer.email", ""),
                        mobile: get(row, "customer.mobile", ""),
                        address: get(row, "customer.address", ""),
                        city: get(row, "customer.city", ""),
                        state: get(row, "customer.state", ""),
                        region_id: get(row, "customer.region_id", ""),
                    },
                    product: {
                        id: get(row, "product.id", ""),
                        name: get(row, "product.name", ""),
                        price: get(row, "product.price", 0),
                        description: get(row, "product.description", ""),
                        image_url: get(row, "product.image_url", ""),
                    },
                    staff: {
                        id: get(row, "staff.id", ""),
                        name: get(row, "staff.name", ""),
                        email: get(row, "staff.email", ""),
                        mobile: get(row, "staff.mobile", ""),
                        role: get(row, "staff.role", ""),
                    },
                    total_amount: get(row, "total_amount", 0),
                    payment_status: get(row, "payment_status", ""),
                    payment_type: get(row, "payment_type", ""),
                    paid_amount: get(row, "paid_amount", 0),
                    remaining_amount: get(row, "remaining_amount", 0),
                    next_payment_date: get(row, "next_payment_date", ""),
                    notes: get(row, "notes", ""),
                    created_at: get(row, "created_at", ""),
                    updated_at: get(row, "updated_at", ""),
                };
            });

        return response;
    } catch (error) {
        throw new Error(error);
    }
};
